import { parsePhoneNumberFromString } from "libphonenumber-js";
import CountryCodes from "./CountryCodes.json";

export const CountryCodeOptions = CountryCodes.map((code, index) => ({
  label: `${code.flag} (${code.dial_code})`,
  value: code.dial_code,
  key: `${code.code}-${index}`,
}));

export const PhoneNumberUtils = {
  validate: (phoneNumber: string, dialCode: string) => {
    const country = CountryCodes.find(c => c.dial_code === dialCode);
    if (!country) return false;
    
    const fullPhoneNumber = dialCode + phoneNumber;
    const phoneNumberObj = parsePhoneNumberFromString(fullPhoneNumber);
    return phoneNumberObj?.isValid() || false;
  },
  
  format: (phoneNumber: string) => {
    const phoneNumberObj = parsePhoneNumberFromString(phoneNumber);
    return {
      value: phoneNumberObj?.formatNational() || phoneNumber,
      countryCode: '+' + phoneNumberObj?.countryCallingCode || ""
    };
  }
};
